import React, { useState } from 'react';
import { RadioButton, ControlLink, Button, Stack } from '@moda/om';
import { ShippingAddressInfoBlock } from '../ShippingAddressInfoBlock/ShippingAddressInfoBlock';
import { RestAddressData } from '../../../hooks/useAddress';
import { Box } from '../../Box';
import { FormButtonsLayout } from '../../FormButtonsLayout';
import './ShippingAddressList.scss';

interface Props {
  addresses: RestAddressData[];
  defaultAddressId: string | undefined;
  onAdd: () => void;
  onCancel: () => void;
  onChange?: (addressId: string) => void;
  onEdit: (id: string) => void;
}

export const ShippingAddressList: React.FC<Props> = ({
  addresses,
  defaultAddressId,
  onAdd,
  onCancel,
  onChange,
  onEdit
}) => {
  const [selectedAddressId, setSelectedAddressId] = useState<string | undefined>(defaultAddressId);

  return (
    <Stack className="ShippingAddressList" space={6}>
      <Stack space={4}>
        {addresses.map((address: RestAddressData) => (
          <Box
            key={address.id}
            className="ShippingAddressList__option"
            tabIndex={0}
            role="button"
            onKeyPress={event => event.key === 'Enter' && setSelectedAddressId(address.id)}
            onClick={() => setSelectedAddressId(address.id)}
          >
            <RadioButton
              checked={address.id === selectedAddressId}
              onChange={() => setSelectedAddressId(address.id)}
              value={address.id}
            />
            <div className="ShippingAddressList__option-main">
              <ShippingAddressInfoBlock data={address.attributes} />
              <ControlLink
                className="ShippingAddressList__option-edit"
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                  event.stopPropagation();
                  onEdit(address.id);
                }}
              >
                Edit
              </ControlLink>
            </div>
          </Box>
        ))}
      </Stack>

      <ControlLink className="ShippingAddressList__add-button" onClick={onAdd}>
        Add New Address
      </ControlLink>

      {selectedAddressId && onChange && addresses.length > 0 && (
        <FormButtonsLayout>
          <Button onClick={onCancel} secondary>
            Cancel
          </Button>

          <Button onClick={() => onChange(selectedAddressId)}>Continue</Button>
        </FormButtonsLayout>
      )}
    </Stack>
  );
};
